import {
  type ApiResponse,
  type PaginatedResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  Subscription,
  SubscriptionStatusEnum,
  CreateSubscriptionInput,
  UpdateSubscriptionInput
} from './types/subscriptions.types';

export interface ListSubscriptionsParams {
  customerId?: number
  status?: SubscriptionStatusEnum
  limit?: number
  offset?: number
}

export async function listSubscriptions(
  params: ListSubscriptionsParams = {},
  token: string
): Promise<PaginatedResponse<Subscription>> {

  const query = new URLSearchParams();

  if (params.customerId !== undefined) {

    query.set('customerId', String(params.customerId));
  }

  if (params.status !== undefined) {

    query.set('status', params.status);
  }

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<Subscription>>(`/subscriptions${ qs }`, undefined, token);
}

export async function getSubscriptionById(
  id: number,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(`/subscriptions/${ id }`, undefined, token);
}

export async function createSubscription(
  input: CreateSubscriptionInput,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(
    '/subscriptions',
    {
      method: 'POST',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function updateSubscription(
  id: number,
  input: UpdateSubscriptionInput,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(
    `/subscriptions/${ id }`,
    {
      method: 'PUT',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function cancelSubscription(
  id: number,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(
    `/subscriptions/${ id }/cancel`,
    {
      method: 'POST'
    },
    token
  );
}

export async function pauseSubscription(
  id: number,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(
    `/subscriptions/${ id }/pause`,
    {
      method: 'POST'
    },
    token
  );
}

export async function resumeSubscription(
  id: number,
  token: string
): Promise<ApiResponse<Subscription>> {

  return apiRequest<ApiResponse<Subscription>>(
    `/subscriptions/${ id }/resume`,
    {
      method: 'POST'
    },
    token
  );
}
